import { useEffect } from 'react';
import { get } from 'lodash';
import { defineMessages, useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';

import GET_COMPANY_TASK_LIST_PARTNERS from '../gql/getCompanyTaskListPartners.graphql';
import toast from 'helpers/toast';

const messages = defineMessages({
  error: {
    id: 'taskList.templates.partners',
    defaultMessage: 'There was an error loading your template partners.',
    description: 'Error message when fetching taskList partners.',
  },
});

const useCompanyTaskListPartners = () => {
  const { formatMessage } = useIntl();
  const { data, loading, error } = useQuery(GET_COMPANY_TASK_LIST_PARTNERS);
  const partners = get(data, 'viewer.company.taskListPartners.nodes', []);

  useEffect(
    () => {
      if (error) {
        toast.error(formatMessage(messages.error));
      }
    },
    [error, formatMessage],
  );

  return {
    partners,
    isLoading: loading,
  };
};

export default useCompanyTaskListPartners;
